import React, { useState } from 'react';
import ConditionalWrapper from '../ConditionalWrapper';
import Uploader from './Uploader';
import { UploaderModal } from './UploaderModal';

const UniversalUploader = ({
  uploaderId,
  accept,
  onComplete,
  onFileError,
  onDelete,
  readOnly,
  showImageLibrary,
  helperText,
  deleteUploadRecord,
  displayInModal,
  modalShown,
  onModalDismiss,
  maxSize,
}) => {
  const [disableDismiss, setDisableDismiss] = useState(false);

  return (
    <ConditionalWrapper
      condition={displayInModal}
      wrapper={children => (
        <UploaderModal
          onDismiss={onModalDismiss}
          shown={modalShown}
          disableDismiss={disableDismiss}
        >
          {children}
        </UploaderModal>
      )}
    >
      <Uploader
        uploaderFileId={uploaderId}
        accept={accept}
        onComplete={onComplete}
        onDelete={onDelete}
        onFileError={onFileError}
        readOnly={readOnly}
        showImageLibrary={showImageLibrary}
        helperText={helperText}
        deleteUploadRecord={deleteUploadRecord}
        maxSize={maxSize}
        setDisableDismiss={setDisableDismiss}
      />
    </ConditionalWrapper>
  );
};

export { UniversalUploader };
